import { clsx } from "clsx";
import { SVGIconProps } from "../interface";
const iconSize: Record<string, string> = {
  8: "h-2",
  12: "h-3",
  16: "h-4",
  24: "h-6",
  32: "h-8",
  40: "h-10",
  48: "h-12",
  56: "h-14",
  80: "h-20",
  124: "h-30",
};
const SvgTimeLoop = ({ title, titleId, size = 16, className }: SVGIconProps) => {
  const sizeClass = iconSize[size];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 20"
      width={size}
      height={size}
      className={clsx(sizeClass, className)}
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M19.001 7c.2.001.39.08.53.22l1.687 1.69.052.056a.75.75 0 0 1-1.056 1.055l-.056-.052L19 8.81 17.843 9.97l-.056.05a.75.75 0 0 1-1.004-1.112l1.687-1.687c.14-.141.332-.22.531-.22" />
      <path d="M.25 10A9.75 9.75 0 0 1 10 .25c3.078 0 5.82 1.43 7.605 3.655a.75.75 0 0 1-1.171.94A8.226 8.226 0 0 0 10 1.75 8.25 8.25 0 0 0 1.75 10 8.25 8.25 0 0 0 10 18.25a8.249 8.249 0 0 0 8.25-8.249v-2.25a.75.75 0 0 1 1.5 0v2.25c0 5.385-4.365 9.749-9.75 9.749A9.75 9.75 0 0 1 .25 10" />
      <path d="M8.97 5.985a.75.75 0 1 1 1.5 0v4.285l3.284 1.955a.75.75 0 0 1-.699 1.325l-.067-.036-3.653-2.173a.75.75 0 0 1-.366-.644z" />
    </svg>
  );
};
export default SvgTimeLoop;
